module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "cloud row mx-auto align-items-center",
    staticStyle: {
      "height": "85vh"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "type-title"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('choose_the_course')))]), _vm._v(" "), _c('p', {
    staticClass: "my-4",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('click_icon_t')) + " "), _c('font-awesome-icon', {
    staticClass: "form_icon",
    attrs: {
      "icon": ['fas', 'bars']
    }
  }), _vm._v(" " + _vm._s(_vm.$t('click_icon_b')))], 1)])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/pic_plant.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/pic_plant.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-829cc1c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/CloudHome.vue
// module id = 800
// module chunks = 3